﻿{
  "createAccount": "Utwórz konto",
  "subscription": "Subskrypcja",
  "oneTimePurchase": "Zakup jednorazowy",
  "billingDetails": "Dane do rozliczenia",
  "paymentDetails": "Szczegóły płatności",
  "requestAQuote": "Firmowy formularz wniosku",
  "reviewOrder": "Przejrzyj zamówienie",
  "thankYouForYourOrder": "Dziękujemy za złożenie zamówienia!",
  "joinTheCommunity": "Dołącz do społeczności",
  "startTrial": "Rozpocznij wersję próbną",
  "yourTrialHasEnded": "Wersja próbna została zakończona",
  "taxExempt": "Zwolnienie z opodatkowania",
  "taxExemptThankYou": "Przesłano pomyślnie!",
  "planDetails": "Szczegóły mojej subskrypcji",
  "modifyPlan": "Zmień plan",
  "modifyPaymentDetails": "Zmień szczegóły płatności",
  "redirect": "Przekierowywanie do Boardmaker",
  "perpetualTrial": "Pobierz bezpłatną {{trialLength}}-dniową wersję próbną",
  "perpetualThankYou": "Oprogramowanie jest gotowe!",
  "downloads": "Pobierz Boardmaker",
  "partner": "Znajdź partnera",
  "intro": "Wybierz produkt Boardmaker poniżej, aby pobrać najnowszą wersję dla swojego urządzenia.",
"systemRequirements": "Wymagania systemowe",
"releaseNotes": "Przegląd informacji o wersji",
"comparison": "Porównaj subskrypcję i licencję"
}
